import { DataTable, ErrorStatusBanner, LayoutGap } from '@gov-nx/ui/web';
import type { RezaPersonTableProps } from '@gov-nx/core/hooks';
import { GridSkeleton } from '../../Skeleton/GridSkeleton';

export const RezaPersonTable = ({
	isPersonLoading,
	isPersonError,
	errorBanner,
	keyValues,
}: RezaPersonTableProps) => {
	if (isPersonLoading) {
		return <GridSkeleton rows={3} />;
	}
	if (isPersonError) {
		return <ErrorStatusBanner {...errorBanner} />;
	}

	return (
		<LayoutGap gap="m">
			<DataTable responsive>
				<tbody>
					{keyValues.map((entry) => (
						<tr key={entry.key}>
							<td className="sm:w-1/2">{entry.key}</td>
							<td className="sm:w-1/2">
								<strong>{entry.value}</strong>
							</td>
						</tr>
					))}
				</tbody>
			</DataTable>
		</LayoutGap>
	);
};
